




























import { Component, Vue } from "vue-property-decorator";
import SFOC from "@/views/referencecurves/SFOC.vue";
import PowerSpeed from "@/views/referencecurves/PowerSpeed.vue";

@Component({
  components: {
    SFOC,
    PowerSpeed,
  },
})
export default class ReferenceCurves extends Vue {
  tab = null;
}
